import { Reward } from '@src/hooks/useArcadeStore';
import { HStack, Text } from 'ui_2';

type Props = {
  reward: Reward;
};
export const ArcadeStoreRewardRow = ({ reward }: Props) => {
  return (
    <div className='w-full'>
      <HStack className='w-full items-center gap-2 rounded-[10px] border border-gray-300 p-2 shadow-[0px_1px_4px_0px_rgba(0,0,0,0.08)] transition-shadow hover:shadow-[0px_2px_8px_1px_rgba(0,0,0,0.12)]'>
        {reward.productSKU.service.smallLogoImageURL && (
          <img
            src={reward.productSKU.service.smallLogoImageURL}
            width={44}
            height={44}
            className='rounded-[10px]'
            alt={`${reward.productSKU.service.title} small logo`}
          />
        )}
        <Text>{reward.productSKU.title}</Text>
      </HStack>
    </div>
  );
};
